var render = function (_h,_vm) {var _c=_vm._c;return _c('q-inner-loading',{attrs:{"showing":_vm.props.loading}},[_c('q-spinner-audio',{attrs:{"size":_vm.props.size,"color":"primary"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }